export const MARKETPLACE_HOMEPAGE_ROUTES = {
  ROOT: '/marketplace',
  BROWSE: '/marketplace',
  DETAILS: '/marketplace/details',
  PROFILE: '/marketplace/profile',
  APP_IDEAS: '/marketplace/app-ideas',
  APP_IDEA_DETAILS: '/marketplace/app-ideas/:ideaId',
} as const;
